import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";

export default function* chargeForChargeDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `charges/${action.payload?.chargeId}`);

    const charge = ChargeFactory.create(res.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchChargeForChargeDetailsPage() {
  yield takeEvery(Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE, chargeForChargeDetailsPage);
}
